var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.2 3v12.6c0 1.0171-.7829 1.8-1.8 1.8-1.01705 0-1.8-.7829-1.8-1.8s.78295-1.8 1.8-1.8v-3.6c-2.96095 0-5.4 2.4391-5.4 5.4s2.43905 5.4 5.4 5.4c2.9609 0 5.4-2.4391 5.4-5.4v-6.78164c1.1091.79006 2.2664 1.38164 3.6 1.38164v-3.6c-.0852 0-1.3272-.39431-2.1937-1.14961-.8666-.7553-1.4063-1.70341-1.4063-2.45039z",
    fill: "currentColor"
  })));
}
export default SvgTiktokreact;